import {
  REQUEST_DONATION_CATEGORY_PARENT_LIST,
  REQUEST_DONATION_CATEGORY_LIST,
  REQUEST_DONATION_CATEGORY_LIST_FOR_CREATE,
} from './mutation-types'

export default {
  [REQUEST_DONATION_CATEGORY_PARENT_LIST](state, receivedData) {
    state.donationCategoryParentList = receivedData
  },
  [REQUEST_DONATION_CATEGORY_LIST](state, receivedData) {
    state.donationCategoryList = receivedData.content
    state.donationCategoryListCount = receivedData.totalElements
  },
  [REQUEST_DONATION_CATEGORY_LIST_FOR_CREATE](state, receivedData) {
    state.donationCategoryListForCreate = receivedData
  },
}